export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sélectionner le compte de l'offrant"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Compte de l'offrant"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select Account"])}
}